import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";

import PageHead from "@/pages/Head";
import Link from "next/link";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import CountDown from "@/components/Maintenance/CountDonw";


const CommingSoon = () => {
  return (
    <>
      <PageHead title="Comming soon - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <div
            className="rbt-countdown-area rbt-maintenance-area bg_image bg_menfis_image--2 bg_image_fixed rbt-section-gap vh-100 d-flex align-items-center justify-content-center"
            data-black-overlay="5"
          >
            <div className="container">
              <div className="row g-5 align-items-center">
                <div className="col-lg-12">
                  <div className="inner">
                    <div className="section-title text-center">
                      <span className="subtitle bg-white-opacity">
                        Under construction
                      </span>
                      <h2 className="title color-white">
                          Sorry, this page is under construction
                      </h2>
                      <p className="description has-medium-font-size mt--20 mb--0 color-white opacity-7">
                        This page is ccurrently under construction, if all goes as
                        planned we&apos;ll be available in
                      </p>
                    </div>
                    <div className="countdown-style-1 mt--50 justify-content-center">
                      <div
                          className="countdown justify-content-center"
                          data-date="2024-10-07"
                      >
                          <CountDown targetDate="2024-10-07" targetTime="18:00:00" />
                      </div>
                    </div>
                    <div className="rbt-header-sec  mt--30 justify-content-center">
                      <Link
                        className="rbt-btn btn-border hover-icon-reverse color-white"
                        href="/"
                      >
                        <div class="icon-reverse-wrapper">
                          <span class="btn-text" data-text="More About University">
                            Regresar al inicio
                          </span>
                          <span class="btn-icon">
                            <i class="feather-arrow-right"></i>
                          </span>
                          <span class="btn-icon">
                            <i class="feather-arrow-right"></i>
                            </span>
                          </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default CommingSoon;
